import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import { ReactComponent as IconOpenLInk } from 'asserts/icons/ic_open_in_window_lined.svg';
import { font } from 'asserts/styles/fonts';

interface LinkButtonProps {
  onClick: () => void;
  label: string;
}

const LinkButton = ({ onClick, label }: LinkButtonProps) => {
  return (
    <Button onClick={onClick}>
      {label} <IconOpenLInk />
    </Button>
  );
};

export default LinkButton;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  height: 32px;
  padding: 8px 12px;
  text-align: center;
  background: ${color.black2};
  color: ${color.white2};
  border-radius: 24px;
  ${font.caption2_medium};

  &:hover {
    box-shadow: 0px 0px 0px 4px rgb(220, 220, 220);
    transition: all 0.3s;
  }
`;
